/* eslint-disable max-len */
import { Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { tableSubCellStyle } from '../current-dispatch/styled';
import { DateType, Position, SlipDetails } from './DispatchSlipData';
import { fieldLabelStyle, iconStyle, tableCellStyle } from './styled';
import { Fragment } from 'react';

export type CheckBoxField = {
  field: keyof SlipDetails,
  title: string
}

const topCheckboxFields: CheckBoxField[] = [
  { field: 'isShip', title: 'Ship' },
  { field: 'isDock', title: 'Dock' },
  { field: 'isWheat', title: 'Wheat' },
];

export const DispatchSlipDetails = ({ slipDetails, page }: { slipDetails: SlipDetails, page: number }) => {
  const warningPage = slipDetails.warnings.find(p => p.page === page);

  const warningsData = warningPage ? warningPage.warning.map(({ warningId, warning }) =>
    ({ jobDescription: `<${warningId}>`, employeeName: warning })) : [];

  const dataRows = [...slipDetails.details[page - 1].positions, ...warningsData];
  const nonDefaultWarningCount = slipDetails.nonDefaultWarnings ? 1 : 0;
  const totalRowsOnPage = slipDetails.details[page - 1]?.positions.length - 1 || 0;
  const detailWarningCount = slipDetails.warnings.find(p => p.page === page)?.warning.length || 0;
  const replacementTransferTextCount = slipDetails.replacmentTransfer?.[page - 1]?.details?.length ? 1 : 0;
  // calculate empty rows that should be appended before and after non default warnings
  const spacerOneCount = Math.floor((20-(nonDefaultWarningCount + totalRowsOnPage + detailWarningCount + 1))/2);
  const spacerTwoCount = Math.floor((20-(nonDefaultWarningCount + totalRowsOnPage + detailWarningCount + replacementTransferTextCount + 1))/2);
  // append data rows
  let data = [...dataRows];
  // append spacer one
  if (spacerOneCount > 0) {
    const spacerOne = Array(spacerOneCount).fill({ employeeName: '' });
    data.push(...spacerOne);
  }
  // append non default warnings
  data.push({ employeeName: slipDetails.nonDefaultWarnings });
  // append spacer two
  if (spacerTwoCount > 0) {
    const spacerTwo = Array(spacerTwoCount).fill({ employeeName: '' });
    data.push(...spacerTwo);
  }
  return (
    <TableContainer>
      <Table size="custom" sx={{ backgroundColor: 'grey.A700' }}>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: 0 }}>
              <Table border={0}>
                <TableBody>
                  <TableRow>
                    <TableCell
                      valign="middle"
                      align="center"
                      sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)}
                    >
                      <Typography sx={fieldLabelStyle}>RTG</Typography>
                    </TableCell>
                    <TableCell
                      valign="middle"
                      align="center"
                      sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, '50%')}
                    >
                      <Table width="100%" border={0}>
                        <TableBody>
                          <TableRow>
                            {
                              topCheckboxFields.map(({ title, field }) => (
                                <TableCell key={title} sx={tableSubCellStyle} valign="middle">
                                  {title}
                                  <img
                                    src={`/assets/images/slip_box${slipDetails[field] ? '_checked' : ''}.gif`}
                                    alt={title}
                                    style={iconStyle}
                                  />
                                </TableCell>
                              ))
                            }
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableCell>
                    <TableCell
                      valign="middle"
                      align="center"
                      sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)}
                    >
                      <Typography sx={fieldLabelStyle}>No.</Typography>
                    </TableCell>
                    <TableCell
                      sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)}
                      valign="middle"
                      align="center"
                    >
                      &nbsp;
                    </TableCell>
                  </TableRow>
                  {
                    data.map((position: Position | undefined, i) => (
                      <Fragment key={i}>
                        <TableRow key={i}>
                          <TableCell align='center' valign="middle" sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)}>
                            <Typography sx={{ ...fieldLabelStyle, color: 'black' }}>
                              {position?.jobDescription}
                            </Typography>
                          </TableCell>
                          <TableCell valign="middle" align="center" sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)} >
                            {
                              position && 'dataType' in position && position?.dataType === DateType.End ? (
                                <img src="/assets/images/tick.gif" alt="WHEAT BOX" style={{ ...iconStyle, top: '3px' }} />
                              ) : position?.employeeName
                            }
                          </TableCell>
                          <TableCell valign="middle" align="center" sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)}>
                            {position?.registrationNumber}
                          </TableCell>
                          <TableCell
                            sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)}
                            valign="middle"
                            align="center"
                          >
                            {position?.warningId && `<${position.warningId}>`}
                          </TableCell>
                        </TableRow>
                        {position?.dataType === DateType.End && slipDetails.replacmentTransfer?.[page - 1]?.details?.map((detail, i) => (
                          <TableRow key={`replacement-${i}`}>
                            <TableCell sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)} />
                            <TableCell
                              sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50%)`)}
                              align="center"
                              valign="middle"
                            >
                              <Typography sx={{ ...fieldLabelStyle, color: 'black', fontWeight: 'bold' }}>
                                {detail}
                              </Typography>
                            </TableCell>
                            <TableCell sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)} />
                            <TableCell sx={(theme) => tableCellStyle(theme, slipDetails.slipColour, `calc(50% / 3)`)} />
                          </TableRow>
                        ))}
                      </Fragment>
                    ))
                  }
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
